module.exports = __webpack_public_path__ + "static/media/The Front Bottoms - Twin Size Mattress (Official).59818277.mp3";